const INITIAL_OBJECT = {};
class Storage {
  constructor() {
    this.storageName = 'xperStorage';
    this.storage = window.localStorage;
    const data = this.storage.getItem(this.storageName);
    this.data = data ? JSON.parse(data) : INITIAL_OBJECT;
    this.save();
  }

  getItem(key) {
    return this.data[key];
  }

  setItem(key, value) {
    this.data[key] = value;
    this.save();
  }

  removeItem(key) {
    this.data[key] = undefined;
    this.save();
  }

  save() {
    this.storage.setItem(this.storageName, JSON.stringify(this.data));
  }

  clear() {
    this.storage.clear();
  }
}

export default new Storage();
